import { make } from "vuex-pathify";
import JSONBigInt from "json-bigint";
import { UserInfo } from "@/types";
import TokenPermissionDecode from "@/assets/ts/tokenPermissionDecode";

const defaultState = () => {
  return {
    userInfo: {
      isLoggedIn: false,
      token: "",
      refreshToken: "",
      username: "",
      sessionStartTime: "",
      userID: 0,
      userFullName: "",
      partnerID: 0,
      partnerName: "",
      passwordExpiresAt: null,
      countyConfig: null,
      featureFlags: {},
      secondaryContexts: [],
      workstationId: 0,
      accountType: ""
    }
  };
};

const state = defaultState();

const mutations = {
  ...make.mutations(state)
};

const tokenPermissionDecode = new TokenPermissionDecode();

const actions = {
  ...make.actions(state),
  setUserInfo(
    { commit }: { commit: Function },
    userInfo: UserInfo & { accountType: string }
  ) {
    return new Promise((resolve, reject) => {
      try {
        const isSSO = localStorage.getItem("ssoData") !== null;
        const userInformation = { ...userInfo };

        if (isSSO) {
          userInformation.isLoggedIn = true;
        }

        if (!userInformation.accountType) {
          const permissionArr = tokenPermissionDecode.getPermission(
            "mvds",
            userInformation.token
          );

          if (permissionArr) {
            userInformation.accountType = tokenPermissionDecode.getAccountTypeFromPermission(
              permissionArr
            );
            if (localStorage.getItem("userInfo")) {
              localStorage.setItem("userInfo", JSON.stringify(userInformation));
            }
            if (isSSO) {
              localStorage.setItem("ssoData", JSON.stringify(userInformation));
            }
          } else {
            throw "PermissionError";
          }
        }
        commit("SET_USER_INFO", Object.assign({}, userInformation));
        resolve(userInformation);
      } catch (err) {
        reject(err);
      }
    });
  },
  setNewToken({ commit }: { commit: Function }, token: string) {
    commit("SET_USER_INFO", Object.assign({}, state.userInfo, { token }));
  },
  setDefaultState({ commit }: { commit: Function }) {
    commit("SET_USER_INFO", Object.assign({}, state, defaultState().userInfo));
  }
};

const getters = {
  ...make.getters(state),
  getTokenExpirationTime() {
    if (state.userInfo.isLoggedIn) {
      const jwtPayloadString = atob(state.userInfo.token.split(".")[1]);
      const jwtPayload = JSONBigInt.parse(jwtPayloadString);
      return jwtPayload.exp;
    } else {
      return undefined;
    }
  },
  getUserID() {
    return state.userInfo.userID;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
